<template>
  <div
    v-if="!isTablet"
    class="repetitor__filters"
  >
    <v-select
      :value="subject"
      :items="filteredSubjectList"
      input-value="id"
      label="Все предметы"
      drop-down-image="/v2/catalog/repetitor/catalog/dropdown.svg"
      class="repetitor__filters_select"
      @change="$emit('update:subject', $event)"
    >
      <template #inner-dropdown>
        <img
          src="/v2/catalog/repetitor/close.svg"
          alt="x"
          class="repetitor__filters_select_close"
        >
      </template>
    </v-select>
    <v-select
      :value="grade"
      :items="filteredGradeList"
      input-value="id"
      label="Все классы"
      drop-down-image="/v2/catalog/repetitor/catalog/dropdown.svg"
      class="repetitor__filters_select"
      @change="$emit('update:grade', $event)"
    >
      <template #inner-dropdown>
        <img
          src="/v2/catalog/repetitor/close.svg"
          alt="x"
          class="repetitor__filters_select_close"
        >
      </template>
    </v-select>
    <v-select
      :value="target"
      :items="filteredTargetList"
      input-value="id"
      label="Все цели"
      drop-down-image="/v2/catalog/repetitor/catalog/dropdown.svg"
      class="repetitor__filters_select"
      @change="$emit('update:target', $event)"
    >
      <template #inner-dropdown>
        <img
          src="/v2/catalog/repetitor/close.svg"
          alt="x"
          class="repetitor__filters_select_close"
        >
      </template>
    </v-select>
  </div>
  <div
    v-else
    class="repetitor__filters-mob"
  >
    <div class="repetitor__filters-mob_header">
      <p>Выбери категории</p>
    </div>

    <div class="repetitor__filters-mob_items">
      <button
        :class="['m-btn', { 'active': subject !== 'all' }]"
        @click="clickMobileCheap('subject')"
      >
        {{ subjectName }}
        <img
          v-if="subject !== 'all'"
          src="/v2/catalog/repetitor/catalog/close-white.svg"
          alt="x"
        >
      </button>
      <button
        :class="['m-btn', { 'active': grade !== 'all' }]"
        @click="clickMobileCheap('grade')"
      >
        {{ gradeName }}
        <img
          v-if="grade !== 'all'"
          src="/v2/catalog/repetitor/catalog/close-white.svg"
          alt="x"
        >
      </button>
      <button
        :class="['m-btn', { 'active': target !== 'all' }]"
        @click="clickMobileCheap('target')"
      >
        {{ targetName }}
        <img
          v-if="target !== 'all'"
          src="/v2/catalog/repetitor/catalog/close-white.svg"
          alt="x"
        >
      </button>
    </div>

    <div
      v-if="mobileFilter"
      class="repetitor__filters-shutter"
      @click="mobileFilter = false"
    >
      <div
        class="repetitor__filters-shutter_body"
        @click.stop
      >
        <button
          class="m-btn repetitor__filters-shutter_close"
          @click="mobileFilter = false"
        >
          <img
            src="/v2/catalog/repetitor/close.svg"
            alt="x"
          >
        </button>

        <div class="repetitor__filters-shutter_block">
          <p>Предмет</p>

          <div class="repetitor__filters-shutter_block_items">
            <template v-for="item in subjectList">
              <button
                v-if="item.id !== 'all'"
                :key="item.id"
                :class="['m-btn', { 'active': item.id === mobileSubject }]"
                @click="mobileSubject = item.id === mobileSubject ? 'all' : item.id"
              >
                {{ item.title }}
                <img
                  v-if="item.id === mobileSubject"
                  src="/v2/catalog/repetitor/catalog/close-white.svg"
                  alt="x"
                >
              </button>
            </template>
          </div>
        </div>

        <div class="repetitor__filters-shutter_block">
          <p>Класс</p>

          <div class="repetitor__filters-shutter_block_items">
            <template v-for="item in gradeList">
              <button
                v-if="item.id !== 'all'"
                :key="item.id"
                :class="['m-btn', { 'active': item.id === mobileGrade }]"
                @click="mobileGrade = item.id === mobileGrade ? 'all' : item.id"
              >
                {{ item.title }}
                <img
                  v-if="item.id === mobileGrade"
                  src="/v2/catalog/repetitor/catalog/close-white.svg"
                  alt="x"
                >
              </button>
            </template>
          </div>
        </div>

        <div class="repetitor__filters-shutter_block">
          <p>Предмет</p>

          <div class="repetitor__filters-shutter_block_items">
            <template v-for="item in targetList">
              <button
                v-if="item.id !== 'all'"
                :key="item.id"
                :class="['m-btn', { 'active': item.id === mobileTarget }]"
                @click="mobileTarget = item.id === mobileTarget ? 'all' : item.id"
              >
                {{ item.title.replace('Подготовка к ', '') }}
                <img
                  v-if="item.id === mobileTarget"
                  src="/v2/catalog/repetitor/catalog/close-white.svg"
                  alt="x"
                >
              </button>
            </template>
          </div>
        </div>

        <div class="repetitor__filters-shutter_bottom">
          <p class="repetitor__filters-shutter_found">
            {{ haveFilter ? `найдено ${mobFilteredCards.length}` : '' }}
          </p>
          <button
            class="repetitor__filters-shutter_apply m-btn"
            @click="applyMobileFilter"
          >
            Применить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VSelect from '~/components/common/vSelect.vue';
import catalogCards, { subjectList, gradeList, targetList } from './repetitorCards';

export default {
  name: 'RepetitorCatalogFilters',
  components: { VSelect },
  props: {
    subject: {
      type: String,
      default: 'all',
    },
    grade: {
      type: String,
      default: 'all',
    },
    target: {
      type: String,
      default: 'all',
    },
  },
  data: () => ({
    mobileFilter: false,

    mobileSubject: 'all',
    mobileGrade: 'all',
    mobileTarget: 'all',

    subjectList,
    gradeList,
    targetList,
  }),
  computed: {
    ...mapGetters({
      isTablet: 'isTablet',
    }),

    /**
     * для фильтров свои значение не учитываем, иначе получается
     * не могу выбрать другой предмет, потому что у отфильтрованных карточек
     * только один предмет, и так по остальным фильтрам
     */
    filteredSubjectList() {
      const filteredCards = this.filteredCards('all', this.grade, this.target);

      const allAvailableSubjects = filteredCards.map((card) => card.subject);
      return subjectList.filter(({ id }) => {
        if (id === 'all') return true;
        return allAvailableSubjects.includes(id);
      });
    },
    filteredGradeList() {
      const filteredCards = this.filteredCards(this.subject, 'all', this.target);

      const allAvailableGrades = filteredCards.map((card) => (
        card.classes ? [card.classes.from, card.classes.to] : []
      )).flat(2);
      let minGrade = Math.min(...allAvailableGrades);
      const maxGrade = Math.max(...allAvailableGrades);

      if (this.target === 'vpr') {
        minGrade = 7;
      }

      return gradeList.filter(({ id }) => {
        if (id === 'all') return true;
        const grade = parseInt(id, 10);
        return grade >= minGrade && grade <= maxGrade;
      });
    },
    filteredTargetList() {
      const filteredCards = this.filteredCards(this.subject, this.grade, 'all');

      const allAvailableCheap = filteredCards.map((card) => card.cheap?.map(({ id }) => id))
        .flat();
      return targetList.filter(({ id }) => {
        if (id === 'all') return true;
        return allAvailableCheap.includes(id);
      });
    },

    subjectName() {
      return this.subjectList.find(({ id }) => id === this.subject).title;
    },
    gradeName() {
      return this.gradeList.find(({ id }) => id === this.grade).title;
    },
    targetName() {
      return this.targetList.find(({ id }) => id === this.target).title;
    },
    haveFilter() {
      return this.mobileSubject !== 'all' || this.mobileGrade !== 'all' || this.mobileTarget !== 'all';
    },

    mobFilteredCards() {
      return this.filteredCards(this.mobileSubject, this.mobileGrade, this.mobileTarget);
    },
  },
  watch: {
    isTablet(val) {
      if (!val) {
        this.mobileFilter = false;
      }
    },
    mobileFilter(val) {
      if (val) {
        this.mobileSubject = this.subject;
        this.mobileGrade = this.grade;
        this.mobileTarget = this.target;
      }

      document.body.style.overflow = val ? 'hidden' : 'auto';
    },
  },
  methods: {
    applyMobileFilter() {
      this.mobileFilter = false;

      this.$emit('update:subject', this.mobileSubject);
      this.$emit('update:grade', this.mobileGrade);
      this.$emit('update:target', this.mobileTarget);
    },

    filteredCards(subj, grd, target) {
      let filteredCards = [...catalogCards];

      if (subj !== 'all') {
        filteredCards = filteredCards.filter(({ subject, free }) => subject === subj || free);
      }

      if (grd !== 'all') {
        const grade = parseInt(grd, 10);
        filteredCards = filteredCards.filter(({ classes, free }) => (
          (classes && grade >= classes.from && grade <= classes.to) || free
        ));
      }

      if (target !== 'all') {
        filteredCards = filteredCards.filter(({ cheap }) => cheap.some((ch) => ch.id === target));
      }

      return filteredCards;
    },

    clickMobileCheap(field) {
      if (field === 'subject') {
        if (this.subject === 'all') {
          this.mobileFilter = true;
        } else {
          this.$emit('update:subject', 'all');
        }
      }
      if (field === 'grade') {
        if (this.grade === 'all') {
          this.mobileFilter = true;
        } else {
          this.$emit('update:grade', 'all');
        }
      }
      if (field === 'target') {
        if (this.target === 'all') {
          this.mobileFilter = true;
        } else {
          this.$emit('update:target', 'all');
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">

.repetitor__filters {
  padding-block: 10px;
  display: flex;
  gap: 20px;
  transition: 300ms;

  position: sticky;
  z-index: 5;
  background-color: $gray-bg;
  top: calc(var(--scale) * 100);

  @include media-down(tablet) {
    margin-bottom: 20px;
  }

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    top: -10px;
    left: 0;
    height: 10px;
    background-color: $gray-bg;
  }

  ::v-deep .repetitor__filters_select {
    width: 295px;
    border: none;
    padding: 13px 20px 16px;

    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $black;

    &:nth-of-type(1) .select_dropdown:before {
      content: 'Предмет';
    }

    &:nth-of-type(2) .select_dropdown:before {
      content: 'Класс';
    }

    &:nth-of-type(3) .select_dropdown {
      @include media-down(desktop) {
        left: auto;
        right: 0;
      }

      &:before {
        content: 'Цель занятия';
      }
    }

    .select_dropdown {
      top: calc(100% + 10px);
      width: 630px;
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      padding: 32px 30px 50px;
      border-radius: 20px;
      border: none;
      filter: drop-shadow(10px 10px 50px rgba(7, 21, 57, 0.1)) drop-shadow(4px 4px 20px rgba(7, 21, 57, 0.05));

      @include media-down(laptop) {
        width: calc(200% + 20px);
      }

      &:before {
        width: 100%;
        margin-bottom: 12px;

        font-weight: 600;
        font-size: 18px;
        line-height: 100%;
        color: $grey2;
      }
    }

    .repetitor__filters_select_close {
      position: absolute;
      z-index: 2;
      top: 10px;
      right: 10px;
      width: 44px;
      height: 44px;
      opacity: 0.5;
      cursor: pointer;

      &:hover {
        opacity: 1;
      }
    }

    &.open {
      border-radius: 16px;
    }

    .select_result,
    .select_inner {
      font-size: inherit;
    }

    .select_item {
      padding: 10px 16px 12px;
      background-color: $ege-card-bg;
      border-radius: 50px;

      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 100%;

      &:hover {
        background-color: $gray-bg;
      }

      &.select_item--selected {
        background-color: $black;
        color: $white-color;
      }
    }
  }
}

.repetitor__filters-mob {
  padding-inline: 8px;

  &_header {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;

    p {
      font-weight: 600;
      font-size: 18px;
      line-height: 100%;
      color: $grey2;
    }
  }

  &_items {
    display: flex;
    overflow-x: auto;
    gap: 2px;

    width: calc(100% + 32px);
    padding-left: 16px;
    margin-left: -16px;

    &::-webkit-scrollbar {
      display: none;
    }

    button {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 10px 16px 12px;
      background-color: $white-color;
      border-radius: 50px;

      font-weight: 700;
      font-size: 14px;
      line-height: 100%;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $black;
      white-space: nowrap;

      &.active {
        background-color: $black;
        color: $white-color;
      }
    }
  }
}

.repetitor__filters-shutter {
  display: grid;
  position: fixed;
  z-index: 51;
  inset: 0;

  &_body {
    position: relative;
    margin-top: auto;
    padding: 32px 16px 16px;
    background-color: $header-card-bg;
    box-shadow: 10px 10px 22px rgba(7, 21, 57, 0.1), 4px 4px 14px rgba(7, 21, 57, 0.05);
    overflow-y: auto;
    height: min(100%, 100vh);
    display: flex;
    flex-direction: column;
  }

  &_close {
    position: fixed;
    z-index: 2;
    right: 0;
    top: 0;
  }

  &_block {
    margin-bottom: 20px;

    p {
      margin-bottom: 16px;
      font-weight: 600;
      font-size: 18px;
      line-height: 100%;
      color: $grey2;
    }

    &_items {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;

      button {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 5px 16px 7px;
        background-color: $white-color;
        border-radius: 50px;

        font-weight: 700;
        font-size: 14px;
        line-height: 100%;
        color: $black;

        &.active {
          background-color: $black;
          color: $white-color;
        }
      }
    }
  }

  &_found {
    margin-top: 8px;

    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    color: $grey2;
  }

  &_apply {
    width: 100%;
    margin-top: 8px;
    padding: 13px;

    background-color: #FA5019;
    border: 2px solid #892808;
    border-radius: 500px;

    font-weight: 600;
    font-size: 18px;
    line-height: 100%;

    color: $white-color;
  }

  &_bottom {
    margin-top: auto;
    background-color: $header-card-bg;
    position: sticky;
    bottom: 0;
  }
}

</style>
